import clienteAxios from "../config/axios";
import tokenAuth from "../config/token";

export async function authUser(datos) {
    try {
        return clienteAxios.post('/user/auth', datos);
    } catch (error) {
        console.log("error en authUser");
        console.log(error);
    }
}

export async function getUser(token) {
    //T0D0: Funcion para enviar el token por headers
    tokenAuth(token);
    return clienteAxios.get(`/user/auth`);
    
}

export async function updateTokenFMC(tokenFMC, userName) {
    return clienteAxios.post(`/user/update/tokenFMC`, {tokenFMC , userName});
}

export async function deleteTokenFMC(token) {
    return clienteAxios.delete(`/user/tokenFMC/${token}`); 
}

export async function getAllUsers() {
    return clienteAxios.get('/user');
}

//Lista liviana de usuarios de un tipo (solo _id, userName, fullName, shortName) para selects.
export async function getUsersAsOptionsByUserType(userType) {
    return clienteAxios.get(`/user/userTypeOptions/${userType}`);
}

export async function updateUser(user) {
    return clienteAxios.put(`/user`, { id: user._id, updates: user});
}

export async function addUser(user, byUser) {
    return clienteAxios.post(`/user`, {user: {...user, userNameA: byUser.userName, userAID: byUser._id}});
}

export async function deleteUser(user) {
    return clienteAxios.delete(`/user`,{data: {id: user._id}});
}

export async function verifyQUsers() {
    return clienteAxios.get('/user/enabled/quantity');
}

export async function getUsersInGroupV(userId) {
    return clienteAxios.get(`/user/${userId}/gruposV`);
}

export async function sendNotificationPushByUserIdGroup(groupId, title, message, linkLabel = '', linkUrl = ''){
    return clienteAxios.post(`/user/sendPushToGroup`, {groupId, title, message, linkLabel, linkUrl});
}

export async function getActivosAllowedByUserId(userId){
    return clienteAxios.get(`/user/getActivosAllowedByUserId/${userId}`);
}

export async function getChecklistsAllowedByUserId(userId){
    return clienteAxios.get(`/user/getChecklistsAllowedByUserId/${userId}`);
}


//--------------Comienzo Seccion Rutas Nuevas para Prueba Gratuita MultiTenant--------------!

export async function signUp(user, captcha) {
    return clienteAxios.post('/user/signUp',user, captcha);
}

export async function confirmEmail(token) {
    return clienteAxios.put(`/user/confirmEmail/${token}`);
}

export async function sendEmailToRecoverPassword(userName,tenantId) {
    return clienteAxios.put(`/user/sendEmailToRecoverPassword/${userName}/${tenantId}`);
}

export async function validateTokenToOverwritePassword(token) {
    return clienteAxios.get(`/user/validateTokenToOverwritePassword/${token}`);
}

export async function overwritePassword(token, password) {
    return clienteAxios.put(`/user/overwritePassword/${token}`, {password});
}

//--------------Fin Seccion Rutas Nuevas para Prueba Gratuita MultiTenant--------------!

export async function saveColumnasPreferences(columnsPreferences){
    return clienteAxios.post(`/user/columnasPreferences`, {columnsPreferences});
}